const createMailToLink = ({ to = "", subject = "", body = "", cc = [], bcc = [] }) => {
    return `mailto:${to}?cc=${cc}&bcc=${bcc}&subject=${subject}&body=${body}`
}

export { createMailToLink }